import React from 'react';

class Welcome extends React.Component {
  constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  render() {
    // let padding_distance = 50;
    // let padding_distance_px = `${padding_distance}px`;
    // let top_padding_distance = `${padding_distance + 64}px`;
    // let left_padding_distance = `${padding_distance + 210}px`;
    let style = {
      height: '500px',
      lineHeight: '500px',
      // border: '10px solid red',
      fontSize: '40px',
      textAlign: 'center',
    }
    return (
      <div style = {style}>
        欢迎登录代理管理系统
      </div>
    )
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Welcome/Welcome.jsx